import * as React from 'react';

class CBREButton extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
    }
    render() {
        return (
            <button className={`button ${this.props.type}`}
                onClick={this.props.onClick}
                disabled={this.props.isDisabled ? true : false}
            >{this.props.label}</button>
        );
    }

}

export default CBREButton;